'use client'

import { Cat, Compass, Home, Landmark, Vote, Wand2 } from 'lucide-react'

/**
 * The nav's icon set.
 *
 * Every route used to carry its own SVG: a filled treasury vault, a coloured
 * cat, a hand-drawn generator. They are now one family of rounded line icons at
 * a single weight and a single colour, the way Clubhouse's tab bar is drawn.
 */
const iconProps = {
  size: 18,
  strokeWidth: 1.75,
  color: 'currentColor',
  absoluteStrokeWidth: true,
}

const routes = () => {
  const r = [
    {
      href: '/',
      title: 'Home',
      Image: <Home {...iconProps} />,
    },
  ]

  r.push({
    href: '/treasury',
    title: 'Treasury',
    Image: <Landmark {...iconProps} />,
  })

  r.push({
    href: '/explorer',
    title: 'Explorer',
    Image: <Compass {...iconProps} />,
  })

  r.push({
    href: '/dewihall',
    title: 'DeWiHall',
    Image: <Vote {...iconProps} />,
  })

  r.push({
    href: '/holdings',
    title: 'My Cats',
    Image: <Cat {...iconProps} />,
  })

  r.push({
    // The generator itself is gone; /generator is the note explaining that.
    href: '/generator',
    title: 'Generator',
    Image: <Wand2 {...iconProps} />,
  })

  return r
}

export default routes
